<template>
    <div id="reservation_list">

        <el-radio-group v-model="tabAction" class="status-filter">
            <el-radio-button v-for="item in $const.TRAVELRESERVATIONSTATUSFILTER" :key="item.value" :label="item.value">{{
                item.label }}</el-radio-button>
            <el-radio-button label="">全部</el-radio-button>
        </el-radio-group>

        <custom-table has-organization="true" ref="customTable" :customOptions="customOptions" :columns="columns" :excel-type="btnPreFn('travel_goods_order_export', false) ? 'TravelGoodsOrder' : ''"
            style="height: 95%">
            <template slot="table-operation">
                <el-table-column label="操作" width="120" fixed="right">
                    <div slot-scope="{ row }" class="custom-action">
                        <el-button type="text" v-if="[5, 6].includes(row.status)"
                            @click="confirmRow(row)">确认行程</el-button>
                        <el-button type="text" v-if="row.status != 5 && row.status != 6"
                            @click="confirmRow(row)">详情</el-button>
                        <el-button type="text" v-if="[5, 6, 7].includes(row.status)"
                            @click="cancelClick(row)">取消</el-button>
                    </div>
                </el-table-column>
            </template>
            <template slot="search-bottom">
                <div class="blueInfo">注意；“待确认”的订单请及时与游客确认行程规划，关联接送订单</div>
            </template>

            <template slot-scope="{ item, row }">
                <template v-if="['created', 'finishTime',].includes(item.prop)">
                    {{ row[item.prop] | filterTime }}
                </template>
                <template v-else-if="item.prop === 'channel'">
                    {{ row.channel | filterConst('TRAVELORDERSOURCE') }}
                </template>
                <template v-else-if="item.prop === 'contactPerson'">
                    <div>{{ row.contactPerson }}</div>
                    <div>{{ row.contactPhone }}</div>
                </template>
                <template v-else-if="item.prop === 'orderDate'">
                    {{ row[item.prop] | filterTime('YYYY-MM-DD') }}
                </template>
                <template v-else-if="item.prop === 'goodsOrderNo'">
                    <span class="link" @click="confirmRow(row)" @dblclick="$utils.dblclickCopy">{{ row.goodsOrderNo
                    }}</span>
                    <el-tag class="ml-5"
                        v-for="item in $const.TRAVELRESERVATIONSTATUS.filter(item => item.value === row.status)"
                        :key="item.value" :type="item.type">{{ item.label }}</el-tag>
                </template>
                <template v-else-if="item.prop === 'price'">
                    <span class="util-money"> ￥{{ row.realFee || row.price }} </span>
                </template>
                <template v-else-if="item.prop === 'refundPrice'">
                    <template v-if="row.status === 60 || row.isTicketChanging === 1">
                        <div v-if="row.status === 60">
                            <span class="util-money">￥{{ row.refundFee || 0 }}</span>
                            <span v-if="row.refundType == 2"> (平台操作)</span>
                            <span v-else> {{ row.refundProportion ? "(" + row.refundProportion + "%手续费" + ")" :
                                "(无手续费)" }}</span>

                        </div>
                        <div v-if="row.isTicketChanging === 1">
                            <span class="util-money">￥{{ row.ticketChangingFee || 0 }}</span>
                            <span> {{ row.ticketChangingProportion ? "(" + row.ticketChangingProportion + "%改签费" + ")"
                                : "(无改签费)"
                            }}</span>
                        </div>
                    </template>
                    <span v-else>-</span>
                </template>
                <template v-else-if="item.prop === 'poolType'">
                    {{ row.poolType | filterConst('LYPOOLTYPE') }}
                </template>
                <template v-else-if="item.prop === 'lineType'">
                    {{ row.lineType | filterConst('LYLINETYPE') }}
                </template>

                <template v-else>
                    <span class="ellipsis-cell" @dblclick="$utils.dblclickCopy">{{ row[item.prop] ? row[item.prop] : "-" }}</span>
                </template>
            </template>
        </custom-table>


        <el-dialog title="取消订单" :visible.sync="refundState" width="330px"
            @close="isCustomRule = false; refundFee = null">
            <template v-if="refundRules.length > 0">
                <div :class="{ 'text-disabled': isCustomRule }">
                    <div class="cancel-money" v-for="(item, index) in refundRules" :key="index">
                        {{ index + 1 }}.预约出行日期{{ item.timeNum }}{{ item.timeType === 1 ? "天" : "小时" }}内申请退款的，按支付金额{{ item.proportion }}%收取手续费
                    </div>


                    <div class="cancel-money">
                        <div class="cancel-money-title">实付金额</div>
                        <div class="util-money">￥{{ rowData.price }}</div>
                    </div>

                    <div class="cancel-money">
                        <div class="cancel-money-title">退款手续费</div>
                        <div>
                            <span v-if="refundFeeObj.refundProportion">退款手续费{{ refundFeeObj.refundProportion }}%</span>
                            <span class="util-money">￥{{ refundFeeObj.refundFee }}</span>
                        </div>
                    </div>
                    <div class="cancel-money">
                        <div class="cancel-money-title">实际退款</div>
                        <div class="cancel-money-money util-money">
                            ￥{{ (rowData.price - refundFeeObj.refundFee).toFixed(2) }}
                        </div>
                    </div>
                </div>

                <hr style="margin:20px 0">

                <div>
                    <div style="display:flex;align-items:center;margin-bottom:10px">
                        <el-checkbox v-model="isCustomRule"></el-checkbox>
                        <p @click="isCustomRule = !isCustomRule" style="cursor: pointer;margin-left:10px">自定义退票手续费</p>
                    </div>
                    <el-input v-model="refundFee" placeholder="请输入要扣除的费用" :disabled="!isCustomRule"
                        @input="() => refundFee = refundFee.replace(/^0[\d]/g, '0').replace(/^[1-9][0-9]{4,}/g, '9999').replace(/(\d\d{0,3}\.?\d{0,2})?.*/g, '$1')"></el-input>
                    <p style="margin-top:10px;font-size: 14px;color:red">注意：手续费不能大于实际支付金额，可输入0</p>
                </div>
            </template>

            <el-form :model="cancelForm" :rules="cancelRules" ref="cancelForm" label-width="80px">
                <el-form-item label="取消原因" prop="reason">
                    <el-select v-model="cancelForm.reason" placeholder="请选择取消原因" style="width: 100%">
                        <el-option label="用户计划有变，暂时不需要了" value="用户计划有变，暂时不需要了"></el-option>
                        <el-option label="用户买多了/买错了" value="用户买多了/买错了"></el-option>
                        <el-option label="商家停业/装修/转让" value="商家停业/装修/转让"></el-option>
                        <el-option label="电话/短信息联系不上用户" value="电话/短信息联系不上用户"></el-option>
                        <el-option label="商品库存不足" value="商品库存不足"></el-option>
                        <el-option label="其他原因" value="其他原因"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注说明" prop="remark" v-if="cancelForm.reason === '其他原因'">
                    <el-input type="textarea" v-model="cancelForm.remark" placeholder="请输入取消原因说明"
                        :maxlength="50"></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="cancelConfirm" :loading="loading">确 认</el-button>
                <el-button @click="refundState = false">取 消</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>

export default {
    name: "reservation_list",
    data() {
        return {
            tabAction: '',
            // 配置项
            customOptions: {
                url: "/api/v1/manage/travelOrder/goods/order/list",
                params: {
                    page: 1, // 页数
                    size: 20, // 每页条数
                },
                search: [
                    { type: "input", field: "goodsOrderNo", name: "预约编号", value: "" },
                    { type: "input", field: "contactPerson", name: "联系人姓名", value: "" },
                    { type: "input", field: "contactPhone", name: "联系电话", value: "" },
                    { type: "input", field: "goodsName", name: "商品名称", value: "" },
                    { type: "select", field: "channel", name: "订单来源", option: this.$const.TRAVELORDERSOURCE, value: "" },
                    { type: "select", field: "poolType", name: "拼车/包车", option: this.$const.LYPOOLTYPE, value: "" },
                    { type: "select", field: "lineType", name: "单程/往返", option: [{ label: '单程', value: 1 }, { label: '往返', value: 3 }], value: "" },
                    { type: "datetime", disabledDate: false, field: "orderDate", name: "预约日期", dateProp: { start: "startOrderDate", end: "endOrderDate" }, value: [] },
                    { type: "datetime", disabledDate: false, field: "created", dateProp: { start: "startTime", end: "endTime" }, name: "下单时间", value: [] },
                    { type: "datetime", disabledDate: false, field: "finishTime", dateProp: { start: "startFinishTime", end: "endFinishTime" }, name: "完成/取消时间", value: [] },
                ],
            },
            // 表头
            columns: [
                { prop: "goodsOrderNo", label: "预约编号", width: 200 },
                { prop: "channel", label: "订单来源", width: 100 },
                { prop: "goodsName", label: "商品名称", minWidth: 200 },
                { prop: "contactPerson", label: "联系信息", width: 180 },
                { prop: "poolType", label: "拼车/包车", width: 100 },
                { prop: "lineType", label: "单程/往返", width: 100 },
                { prop: "price", label: "实付金额", width: 100 },
                { prop: "refundPrice", label: "退改金额", width: 140 },
                { prop: "orderDate", label: "预约日期", width: 100 },
                { prop: "created", label: "下单时间", width: 120 },
                { prop: "finishTime", label: "完成/取消时间", width: 120 },
                { prop: "remark", label: "备注", minWidth: 150 },
            ],
            cancelForm: {
                reason: '',
                remark: '',
            },
            cancelRules: {
                reason: [
                    { required: true, message: '请选择取消原因', trigger: 'change' }
                ],
                remark: [
                    { required: true, message: '请输入取消原因说明', trigger: ['blur', 'change'] }
                ]
            },
            rowData: {},
            refundState: false,
            isCustomRule: false,
            refundFee: '',
            refundRules: [],
            refundFeeObj: {},
            loading: false,
        };
    },
    watch: {
        tabAction(val) {
            this.customOptions.params.page = 1;
            if (typeof val === 'string') {
                this.customOptions.params.statusList = val;
                this.customOptions.params.status = null;
            }else{
                this.customOptions.params.status = val != "all" ? val : null;
                this.customOptions.params.statusList = null;
            }
            
            this.$refs.customTable.listFn();
        },
    },
    created() {
        this.tabAction = '5,6,7';

    },
    methods: {
        async getRefundRules() {
            let url = "/api/v1/manage/travelOrder/goodsOrder/refundRules";
            let { code, data } = await this.$axios.get(url, {
                id: this.rowData.id
            });
            if (code === 1) {
                this.refundRules = data || [];
            }
        },
        async getRefundFeeObj() {
            let url = "/api/v1/manage/travelOrder/goodsOrder/getRefundFee";
            let { code, data } = await this.$axios.get(url, {
                id: this.rowData.id
            });
            if (code === 1) {
                this.refundFeeObj = data || [];
                return true;
            } else {
                return false;
            }
        },
        async cancelClick(row) {
            this.rowData = row;
            let res = await this.getRefundFeeObj();
            if (!res) {
                return;
            }
            await this.getRefundRules();
            this.cancelForm.reason = '';
            this.cancelForm.remark = '';
            this.refundState = true;
            // if (this.refundRules && this.refundRules.length > 0) {
            //     this.refundState = true;
            // } else {
            //     this.$confirm("确认要取消本订单吗?", "退票提示").then(async () => {
            //         this.postCancel();
            //     });
            // }
        },
        async cancelConfirm() {
            if (this.isCustomRule && this.refundFee.trim() === '') {
                this.$message.warning('请输入要扣除的费用');
                return;
            }
            await this.postCancel();
        },
        async postCancel() {
            let params = {
                id: this.rowData.id,
                cancelReason: this.cancelForm.reason === '其他原因' ? this.cancelForm.remark : this.cancelForm.reason
            };
            if (this.isCustomRule) {
                params.refundFee = this.refundFee;
            }
            this.$refs.cancelForm.validate(async (valid) => {
                if (valid) {
                    let url = "/api/v1/manage/travelOrder/goods/order/cancel"
                    let { code } = await this.$axios.post(url, params)
                    if (code == 1) {
                        this.$message.success('订单取消成功');
                        this.refundState = false;
                        this.$refs.customTable.listFn();
                    }
                }
            });
        },
        confirmRow(row) {
            this.$router.push({
                path: '/travelReservationDetail',
                query: {
                    id: row.id
                }
            })
        },
    },
};
</script>

<style lang="less" scoped>
#reservation_list {
    // 状态筛选
    .status-filter {
        margin-bottom: 16px;
        background: #f5f7fa;
        border-radius: 8px;
        padding: 4px;
        display: inline-flex;
        
        /deep/ .el-radio-button {
            margin: 0 2px;
            
            .el-radio-button__inner {
                background: transparent;
                border: none;
                border-radius: 6px;
                padding: 8px 16px;
                font-size: 13px;
            }
            
            &.is-active .el-radio-button__inner {
                background: #2B77FF;
                color: #fff;
                box-shadow: none;
            }
        }
    }

    // 操作按钮
    .custom-action {
        display: flex;
        align-items: center;
        gap: 8px;
        
        .el-button--text {
            padding: 0;
            color: #2B77FF;
            
            &:hover {
                color: #1a5fd9;
            }
        }
    }

    // 提示信息
    .blueInfo {
        background: #f0f7ff;
        border-radius: 6px;
        padding: 10px 16px;
        color: #2B77FF;
        font-size: 13px;
        margin-top: 12px;
        border: 1px solid #d4e8ff;
    }

    // 链接样式
    .link {
        color: #2B77FF;
        cursor: pointer;
        
        &:hover {
            text-decoration: underline;
        }
    }

    // 价格样式
    .util-money {
        font-weight: 600;
        color: #F56C6C;
    }

    // 标签间距
    .ml-5 {
        margin-left: 5px;
    }

    // 弹窗样式
    :deep(.el-dialog) {
        border-radius: 8px;
        
        .el-dialog__header {
            padding: 16px 20px;
            border-bottom: 1px solid #ebeef5;
            
            .el-dialog__title {
                font-size: 16px;
                font-weight: 600;
                color: #303133;
            }
        }
        
        .el-dialog__body {
            padding: 20px;
        }
        
        .el-dialog__footer {
            padding: 12px 20px;
            border-top: 1px solid #ebeef5;
            
            .el-button {
                border-radius: 6px;
            }
        }
    }
}

.cancel-money {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px dashed #ebeef5;

    &:last-of-type {
        border-bottom: none;
    }

    .cancel-money-title {
        font-weight: 500;
        color: #606266;
    }

    .cancel-money-money {
        font-weight: 600;
        font-size: 16px;
    }

    .util-money {
        padding-left: 8px;
        color: #F56C6C;
        font-weight: 600;
    }
}

.cancel-money+.cancel-money {
    padding-top: 12px;
}

.text-disabled {
    opacity: 0.5;
}

.ellipsis-cell {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
